import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { clientAccountInitialValues } from 'components/organisms/forms/client-account/ClientAccountForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  useGetClientAccount,
  useUpdateClientAccount,
} from 'services/client-account';
import { IClientAccountForm } from 'services/client-account/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getLastPathname } from 'utils/navbar/getParentPathname';
const EditClientAccount = () => {
  const accountId = useParamId('client-account');
  const account = useGetClientAccount(accountId);
  const navigate = useNavigate();
  const i18nextPrefix = 'user';
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const { mutateAsync, isPending } = useUpdateClientAccount();

  const mutateOptions = useMutateOptions<IClientAccountForm>();

  const onSubmit = async (
    values: IClientAccountForm,
    helpers: FormikHelpers<IClientAccountForm>
  ) => {
    const body = middleware.clientAccount.formToMutation(values);

    await mutateAsync(
      { ...body, id: accountId },
      {
        ...mutateOptions(helpers),
        onSuccess: ({ id }) => {
          navigate(`/client-account/${id}/${getLastPathname(pathname)}`);
        },
      }
    );
  };

  return (
    <Form.ClientAccount
      i18nextPrefix={i18nextPrefix}
      tittle={account.data?.name ?? '-'}
      initialValues={
        account.data
          ? middleware.clientAccount.queryToForm(account.data)
          : clientAccountInitialValues
      }
      backPath={`client-account/${accountId}/${getLastPathname(pathname)}`}
      onSubmit={onSubmit}
      status={{ displayMode: false, isLoading: account.isLoading }}
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.save')} />
        </Button>
      }
    />
  );
};

export default EditClientAccount;
